module.exports = __webpack_public_path__ + "static/media/coffee-pin.18ac2102.svg";